export default "__VITE_ASSET__a5c91527__"